/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { Login2 } from './components/Login2'
import { ForgotPassword } from './components/ForgotPassword'
import { Registration } from './components/Registration'

export function AuthPage2() {
  useEffect(() => {
    document.body.classList.remove('bg-white', 'page-loading')
    return () => {}
  }, [])

  return (
    <Switch>
      <Route path='/login' component={Login2} />
      <Route path='/registration' component={Registration} />
      <Route path='/forgot-password' component={ForgotPassword} />
      <Redirect to='/login' />
    </Switch>
  )
}
